export default {
  qchem: {
    accordionTitle: `Source code for generating the dataset`,
    text: `This dataset was generated by the PennyLane team. A GitHub repository has been created to hold the code for generating PennyLane datasets. To view, run, or adapt the code, please access it through the GitHub repository below.`,
  },
  qspin: {
    accordionTitle: `Source code for generating the dataset`,
    text: `This dataset was generated by the PennyLane team. A GitHub repository has been created to hold the code for generating PennyLane datasets. To view, run, or adapt the code, please access it through the GitHub repository below.`,
  },
  other: {
    accordionTitle: `Source code for generating the dataset`,
    text: `Please access the source code via the link below.`,  
  },
}
